module.exports = __webpack_public_path__ + "img/AFMS_HARSH_ACC.c306a979.png";